//#region Libraries
import styled from "styled-components";
import ScheduleActivityCard from "views/components/Schedules/components/ScheduleActivityCard/ScheduleActivityCard";
//#endregion

const AppointmentScheduleActivityCard = styled(ScheduleActivityCard)`
    &.inactivity.past {
        background-color: var(--gray-1);
        & h5 {
            color: var(--gray-2);
        }
    }
    &.adviser {
        pointer-events: none;
    }
`;

export default AppointmentScheduleActivityCard;